import { Box, ChakraSelect, Text } from '@elkaso-app/web-design';
import { useSearchSuppliersApi } from 'apis/supplier';
import { useMemo, useState } from 'react';
import type { SupplierOption } from './editable-deal-row.types';

interface Props {
  value: SupplierOption | null;
  isInvalid?: boolean;
  onChange: (supplier: SupplierOption | null) => void;
}

export const SupplierSelectCell = ({ value, isInvalid, onChange }: Props) => {
  const [search, setSearch] = useState('');
  const { data, isLoading } = useSearchSuppliersApi(search, { enabled: search.length >= 2 });

  const options = useMemo(
    () =>
      (data?.data ?? []).map((s) => ({
        value: s.id,
        label: s.name,
        countryCode: s.countryCode ?? '',
      })),
    [data]
  );

  const selected = value ? { value: value.id, label: value.name, countryCode: value.countryCode } : null;

  return (
    <Box minW='170px'>
      <ChakraSelect
        size='sm'
        options={options}
        value={selected}
        isLoading={isLoading}
        isInvalid={isInvalid}
        placeholder='Supplier...'
        // Portal the menu to body so the grid's scroll/overflow container can't clip it.
        menuPortalTarget={document.body}
        menuPosition='fixed'
        styles={{ menuPortal: (base: any) => ({ ...base, zIndex: 9999 }) }}
        onInputChange={(input: string) => setSearch(input)}
        filterOption={() => true}
        onChange={(opt: any) => {
          setSearch('');
          onChange(opt ? { id: opt.value, name: opt.label, countryCode: opt.countryCode ?? '' } : null);
        }}
        noOptionsMessage={() => (search.length < 2 ? 'Type at least 2 characters' : 'No suppliers found')}
      />
      {value && value.countryCode && (
        <Text fontSize='xs' color='gray.500' lineHeight='short' mt='0.5'>
          {value.countryCode}
        </Text>
      )}
    </Box>
  );
};
